import { Helmet } from "react-helmet";
import api from "./api";
import { useEffect, useState } from "react";

const AppHelmet = ({ mainDomain = "toolkit.fena.co" }) => {
  const currentHost = window.location.hostname;
  const [customization, setCustomization] = useState<any>(null);
  const [loadingCustomization, setLoadingCustomization] = useState<any>(true);

  useEffect(() => {
    if (window) {
      if (window.location.href?.includes("fena.co")) {
        // do not customize
        setLoadingCustomization(false);
      } else {
        const url = new URL(window.location.href);
        const origin = url.hostname;
        // call for logo for custom domain
        executeLogoCustomization(origin);
      }
    }
  }, []);

  const executeLogoCustomization = async (domain: string) => {
    if (!customization) {
      const encodedUrl = encodeURIComponent(domain);
      const customization = await api.getCustomizationSettingsForLanding(
        encodedUrl
      );
      if (customization) {
        setCustomization(customization);
        setLoadingCustomization(false);
      } else {
        setLoadingCustomization(false);
      }
    }
  };

  useEffect(() => {}, [loadingCustomization]);
  return (
    <Helmet>
      {currentHost !== mainDomain && (
        <meta name="robots" content="noindex, nofollow" />
      )}

      {currentHost !== mainDomain &&
      !loadingCustomization &&
      customization?.customizationForPartnerEnabled === "true" &&
      typeof customization?.faviconTitle === "string" &&
      customization?.faviconTitle.trim() !== "" ? (
        <title>{customization.faviconTitle}</title>
      ) : (
        <title>Fena Toolkit</title>
      )}

      {currentHost !== mainDomain &&
      !loadingCustomization &&
      customization?.customizationForPartnerEnabled === "true" &&
      typeof customization?.faviconLogo === "string" &&
      customization?.faviconLogo.trim() !== "" ? (
        <link rel="icon" type="image/png" href={customization.faviconLogo} />
      ) : (
        <link rel="icon" href="/favicon.png" />
      )}
    </Helmet>
  );
};

export default AppHelmet;
